import { useState } from "react";

const NAV = [
  { id: "dashboard", label: "Dashboard", icon: "grid" },
  { id: "analytics", label: "Analytics", icon: "chart" },
  { id: "users", label: "Users", icon: "users" },
  { id: "admin", label: "Admin Panel", icon: "shield" },
  { id: "settings", label: "Settings", icon: "settings" },
];

function Icon({ name, size = 18, color = "currentColor" }) {
  const icons = {
    grid: <><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /></>,
    chart: <><line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /></>,
    users: <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></>,
    shield: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></>,
    settings: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></>,
    bell: <><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /></>,
    search: <><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></>,
    menu: <><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></>,
    logout: <><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></>,
    pulse: <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {icons[name]}
    </svg>
  );
}

export default function Layout({ page, setPage, onLogout, user, children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [searchFocus, setSearchFocus] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  const sw = collapsed ? 72 : 240;

  const pageTitles = { dashboard: "Dashboard", analytics: "Analytics", users: "User Management", admin: "Admin Panel", settings: "Settings" };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#0A0E17", fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: #0A0E17; }
        ::-webkit-scrollbar { width: 4px; } ::-webkit-scrollbar-track { background: transparent; } ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 4px; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }
        @keyframes spin { to { transform: rotate(360deg); } }
        .page-anim { animation: fadeIn 0.35s ease; }
        @media (max-width: 768px) { .sidebar { transform: translateX(-100%); } .sidebar.open { transform: translateX(0); } .main { margin-left: 0 !important; } }
      `}</style>

      {/* Mobile overlay */}
      {mobileOpen && <div onClick={() => setMobileOpen(false)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 40, backdropFilter: "blur(4px)" }} />}

      {/* SIDEBAR */}
      <aside className={`sidebar${mobileOpen ? " open" : ""}`} style={{
        width: sw, minHeight: "100vh", background: "rgba(10,14,23,0.98)",
        borderRight: "1px solid rgba(255,255,255,0.06)",
        position: "fixed", top: 0, left: 0, zIndex: 50,
        display: "flex", flexDirection: "column",
        transition: "width 0.3s cubic-bezier(0.4,0,0.2,1)",
        backdropFilter: "blur(20px)",
      }}>
        {/* Logo */}
        <div style={{ padding: collapsed ? "22px 16px" : "22px 20px", borderBottom: "1px solid rgba(255,255,255,0.06)", display: "flex", alignItems: "center", justifyContent: collapsed ? "center" : "space-between", overflow: "hidden", minHeight: 70 }}>
          {!collapsed && (
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 34, height: 34, borderRadius: 10, background: "linear-gradient(135deg,#6EE7B7,#60A5FA)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 0 18px rgba(110,231,183,0.3)" }}>
                <Icon name="pulse" size={16} color="white" />
              </div>
              <span style={{ fontSize: 17, fontWeight: 800, color: "#E8EDF5", letterSpacing: "-0.02em", whiteSpace: "nowrap" }}>InsightForge</span>
            </div>
          )}
          {collapsed && (
            <div style={{ width: 34, height: 34, borderRadius: 10, background: "linear-gradient(135deg,#6EE7B7,#60A5FA)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 18px rgba(110,231,183,0.3)" }}>
              <Icon name="pulse" size={16} color="white" />
            </div>
          )}
          {!collapsed && (
            <button onClick={() => setCollapsed(true)} style={btnReset}
              onMouseEnter={e => e.currentTarget.style.color = "#E8EDF5"}
              onMouseLeave={e => e.currentTarget.style.color = "#4B5563"}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="15 18 9 12 15 6" /></svg>
            </button>
          )}
          {collapsed && (
            <button onClick={() => setCollapsed(false)} style={{ ...btnReset, position: "absolute", top: 26, right: -10, background: "#0D1117", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 6, padding: 2, zIndex: 10 }}
              onMouseEnter={e => e.currentTarget.style.color = "#E8EDF5"}
              onMouseLeave={e => e.currentTarget.style.color = "#4B5563"}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="9 18 15 12 9 6" /></svg>
            </button>
          )}
        </div>

        {/* Nav */}
        <nav style={{ padding: "16px 10px", flex: 1, overflowY: "auto" }}>
          {!collapsed && <p style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", color: "#374151", padding: "0 10px", marginBottom: 8 }}>NAVIGATION</p>}
          {NAV.map(item => {
            const active = page === item.id;
            return (
              <button key={item.id} onClick={() => { setPage(item.id); setMobileOpen(false); }}
                style={{
                  width: "100%", display: "flex", alignItems: "center", gap: 12,
                  padding: collapsed ? "12px" : "10px 14px",
                  justifyContent: collapsed ? "center" : "flex-start",
                  borderRadius: 10, marginBottom: 3, cursor: "pointer",
                  background: active ? "rgba(110,231,183,0.1)" : "transparent",
                  border: active ? "1px solid rgba(110,231,183,0.2)" : "1px solid transparent",
                  color: active ? "#6EE7B7" : "#8892a4",
                  transition: "all 0.18s ease", position: "relative",
                  fontFamily: "inherit",
                }}
                onMouseEnter={e => { if (!active) { e.currentTarget.style.background = "rgba(255,255,255,0.04)"; e.currentTarget.style.color = "#E8EDF5"; } }}
                onMouseLeave={e => { if (!active) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#8892a4"; } }}
                title={collapsed ? item.label : ""}
              >
                {active && <div style={{ position: "absolute", left: 0, top: "50%", transform: "translateY(-50%)", width: 3, height: "55%", background: "#6EE7B7", borderRadius: "0 3px 3px 0" }} />}
                <Icon name={item.icon} size={17} color={active ? "#6EE7B7" : "currentColor"} />
                {!collapsed && <span style={{ fontSize: 13.5, fontWeight: active ? 700 : 500, whiteSpace: "nowrap" }}>{item.label}</span>}
                {!collapsed && item.id === "admin" && <span style={{ marginLeft: "auto", fontSize: 10, background: "rgba(248,113,113,0.15)", color: "#F87171", border: "1px solid rgba(248,113,113,0.2)", padding: "1px 7px", borderRadius: 20, fontWeight: 700 }}>NEW</span>}
              </button>
            );
          })}
        </nav>

        {/* Logout + User */}
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", padding: "12px 10px" }}>
          <button onClick={onLogout}
            style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, padding: collapsed ? "10px" : "10px 14px", justifyContent: collapsed ? "center" : "flex-start", borderRadius: 10, cursor: "pointer", background: "transparent", border: "1px solid transparent", color: "#8892a4", transition: "all 0.18s ease", fontFamily: "inherit", marginBottom: 8 }}
            onMouseEnter={e => { e.currentTarget.style.background = "rgba(248,113,113,0.08)"; e.currentTarget.style.color = "#F87171"; e.currentTarget.style.borderColor = "rgba(248,113,113,0.2)"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#8892a4"; e.currentTarget.style.borderColor = "transparent"; }}
            title={collapsed ? "Logout" : ""}
          >
            <Icon name="logout" size={16} color="currentColor" />
            {!collapsed && <span style={{ fontSize: 13, fontWeight: 500 }}>Logout</span>}
          </button>
          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: collapsed ? "8px 0" : "8px 14px", overflow: "hidden" }}>
            <div style={{ width: 32, height: 32, borderRadius: 9, background: "linear-gradient(135deg,#A78BFA,#60A5FA)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, color: "white", flexShrink: 0 }}>{user?.avatar || "U"}</div>
            {!collapsed && (
              <div style={{ overflow: "hidden" }}>
                <p style={{ fontSize: 13, fontWeight: 700, color: "#E8EDF5", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{user?.name || "User"}</p>
                <p style={{ fontSize: 11, color: "#8892a4" }}>{user?.role || "Member"}</p>
              </div>
            )}
          </div>
        </div>
      </aside>

      {/* MAIN */}
      <div className="main" style={{ flex: 1, marginLeft: sw, transition: "margin-left 0.3s cubic-bezier(0.4,0,0.2,1)", minWidth: 0, display: "flex", flexDirection: "column" }}>
        {/* NAVBAR */}
        <header style={{ height: 62, background: "rgba(10,14,23,0.9)", borderBottom: "1px solid rgba(255,255,255,0.06)", backdropFilter: "blur(20px)", display: "flex", alignItems: "center", padding: "0 24px", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 30 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <button onClick={() => setMobileOpen(v => !v)} style={{ ...btnReset, display: "none" }} className="mob-menu">
              <Icon name="menu" size={20} />
            </button>
            <div>
              <h2 style={{ fontSize: 17, fontWeight: 800, color: "#E8EDF5", letterSpacing: "-0.01em" }}>{pageTitles[page] || "Dashboard"}</h2>
              <p style={{ fontSize: 11, color: "#4B5563" }}>Welcome back, {user?.name?.split(" ")[0] || "there"} 👋</p>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {/* Search */}
            <div style={{ display: "flex", alignItems: "center", gap: 8, background: searchFocus ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.03)", border: `1px solid ${searchFocus ? "rgba(110,231,183,0.3)" : "rgba(255,255,255,0.08)"}`, borderRadius: 10, padding: "7px 12px", transition: "all 0.2s" }}>
              <Icon name="search" size={14} color="#8892a4" />
              <input value={searchVal} onChange={e => setSearchVal(e.target.value)}
                onFocus={() => setSearchFocus(true)} onBlur={() => setSearchFocus(false)}
                placeholder="Search..." style={{ background: "none", border: "none", outline: "none", color: "#E8EDF5", fontSize: 13, width: 140, fontFamily: "inherit" }} />
            </div>

            {/* Notifications */}
            <div style={{ position: "relative" }}>
              <button onClick={() => { setNotifOpen(v => !v); setProfileOpen(false); }}
                style={{ width: 36, height: 36, borderRadius: 9, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", cursor: "pointer", color: "#8892a4", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", transition: "all 0.15s" }}
                onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.08)"; e.currentTarget.style.color = "#E8EDF5"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.04)"; e.currentTarget.style.color = "#8892a4"; }}>
                <Icon name="bell" size={16} />
                <span style={{ position: "absolute", top: 7, right: 7, width: 7, height: 7, background: "#6EE7B7", borderRadius: "50%", border: "2px solid #0A0E17" }} />
              </button>
              {notifOpen && (
                <div style={{ position: "absolute", top: 46, right: 0, width: 290, background: "rgba(13,17,28,0.98)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 14, boxShadow: "0 20px 50px rgba(0,0,0,0.6)", backdropFilter: "blur(20px)", zIndex: 100, overflow: "hidden" }}>
                  <div style={{ padding: "14px 16px", borderBottom: "1px solid rgba(255,255,255,0.06)", display: "flex", justifyContent: "space-between" }}>
                    <span style={{ fontWeight: 700, fontSize: 14, color: "#E8EDF5" }}>Notifications</span>
                    <span onClick={() => setNotifOpen(false)} style={{ fontSize: 12, color: "#6EE7B7", cursor: "pointer" }}>Mark all read</span>
                  </div>
                  {[
                    { icon: "💰", text: "Revenue milestone: $1M reached!", time: "2m ago", unread: true },
                    { icon: "👤", text: "New enterprise client onboarded", time: "1h ago", unread: true },
                    { icon: "📊", text: "Monthly report is ready", time: "3h ago", unread: false },
                    { icon: "⚙️", text: "System update completed", time: "1d ago", unread: false },
                  ].map((n, i) => (
                    <div key={i} style={{ padding: "12px 16px", display: "flex", gap: 10, alignItems: "flex-start", cursor: "pointer", borderBottom: "1px solid rgba(255,255,255,0.04)", background: n.unread ? "rgba(110,231,183,0.03)" : "transparent", transition: "background 0.15s" }}
                      onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.03)"}
                      onMouseLeave={e => e.currentTarget.style.background = n.unread ? "rgba(110,231,183,0.03)" : "transparent"}>
                      <span style={{ fontSize: 16 }}>{n.icon}</span>
                      <div style={{ flex: 1 }}>
                        <p style={{ fontSize: 13, color: n.unread ? "#E8EDF5" : "#8892a4", margin: 0, fontWeight: n.unread ? 600 : 400 }}>{n.text}</p>
                        <p style={{ fontSize: 11, color: "#4B5563", margin: "3px 0 0" }}>{n.time}</p>
                      </div>
                      {n.unread && <div style={{ width: 7, height: 7, borderRadius: "50%", background: "#6EE7B7", marginTop: 4, flexShrink: 0 }} />}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Profile */}
            <div style={{ position: "relative" }}>
              <button onClick={() => { setProfileOpen(v => !v); setNotifOpen(false); }}
                style={{ display: "flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 10, padding: "5px 10px 5px 5px", cursor: "pointer", transition: "all 0.15s" }}
                onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.08)"}
                onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.04)"}>
                <div style={{ width: 28, height: 28, borderRadius: 8, background: "linear-gradient(135deg,#A78BFA,#60A5FA)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "white" }}>{user?.avatar || "U"}</div>
                <span style={{ fontSize: 13, fontWeight: 600, color: "#E8EDF5" }}>{user?.name?.split(" ")[0]}</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8892a4" strokeWidth="2.5"><polyline points="6 9 12 15 18 9" /></svg>
              </button>
              {profileOpen && (
                <div style={{ position: "absolute", top: 46, right: 0, width: 220, background: "rgba(13,17,28,0.98)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 14, boxShadow: "0 20px 50px rgba(0,0,0,0.6)", backdropFilter: "blur(20px)", zIndex: 100, overflow: "hidden" }}>
                  <div style={{ padding: "16px", borderBottom: "1px solid rgba(255,255,255,0.06)", display: "flex", gap: 10, alignItems: "center" }}>
                    <div style={{ width: 38, height: 38, borderRadius: 10, background: "linear-gradient(135deg,#A78BFA,#60A5FA)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700, color: "white" }}>{user?.avatar}</div>
                    <div>
                      <p style={{ fontSize: 14, fontWeight: 700, color: "#E8EDF5", margin: 0 }}>{user?.name}</p>
                      <p style={{ fontSize: 11, color: "#8892a4", margin: 0 }}>{user?.email}</p>
                    </div>
                  </div>
                  {[
                    { label: "My Profile", action: () => { setPage("settings"); setProfileOpen(false); } },
                    { label: "Settings", action: () => { setPage("settings"); setProfileOpen(false); } },
                    { label: "Admin Panel", action: () => { setPage("admin"); setProfileOpen(false); } },
                  ].map((item, i) => (
                    <button key={i} onClick={item.action}
                      style={{ width: "100%", padding: "11px 16px", background: "none", border: "none", borderBottom: "1px solid rgba(255,255,255,0.04)", cursor: "pointer", color: "#C8D0DC", fontSize: 13, textAlign: "left", fontFamily: "inherit", transition: "background 0.15s" }}
                      onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.04)"}
                      onMouseLeave={e => e.currentTarget.style.background = "none"}>
                      {item.label}
                    </button>
                  ))}
                  <button onClick={onLogout}
                    style={{ width: "100%", padding: "11px 16px", background: "none", border: "none", cursor: "pointer", color: "#F87171", fontSize: 13, textAlign: "left", fontFamily: "inherit", transition: "background 0.15s" }}
                    onMouseEnter={e => e.currentTarget.style.background = "rgba(248,113,113,0.06)"}
                    onMouseLeave={e => e.currentTarget.style.background = "none"}>
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="page-anim" key={page} style={{ flex: 1, padding: "24px 24px 48px", overflowY: "auto", maxWidth: 1400, width: "100%", margin: "0 auto" }}>
          {children}
        </main>
      </div>
    </div>
  );
}

const btnReset = { background: "none", border: "none", cursor: "pointer", color: "#4B5563", display: "flex", alignItems: "center", justifyContent: "center", padding: 4, borderRadius: 6, fontFamily: "inherit" };